import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ReportProvider } from 'src/app/providers';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { ReportVersion } from 'src/app/model';
import { ReportState } from 'src/app/model/Enums';
import { ReportService, ToasterService } from 'src/app/services';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ShowNoteModalComponent } from 'src/app/components';

@Component({
  selector: 'app-dashboard-report',
  templateUrl: './dashboard-report.component.html',
  styleUrls: ['./dashboard-report.component.scss']
})
export class DashboardReportComponent implements OnInit, OnDestroy {

  private subscribeParams: Subscription;

  userImage1: string = 'https://i.insider.com/5899ffcf6e09a897008b5c04?width=600&format=jpeg&auto=webp';
  userImage2: string = 'https://bramdejager.files.wordpress.com/2019/05/bramdejager-600x600.png?w=300';
  userImage3: string = 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8dXNlcnxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&w=1000&q=80';

  reportId: string = '';

  reportVersionList: Array<ReportVersion> = [];
  mainReportVersion: ReportVersion = null;
  reportStateEnum = ReportState;

  constructor(private _location: Location,
    private reportProvider: ReportProvider,
    public reportService: ReportService,
    private activatedRoute: ActivatedRoute,
    private modalService: BsModalService,
    private toastr: ToasterService) { }

  ngOnInit(): void {
    this.subscribeParams = this.activatedRoute.queryParams.subscribe(resRoute => {
      this.reportId = resRoute.id ? resRoute.id : '';

      if (this.reportId)
        this.getAllVersionList();

    });
  }

  ngOnDestroy(): void {
    if (this.subscribeParams)
      this.subscribeParams.unsubscribe();
  }

  /**
  * @description handle browser back button
  */
  goBack() {
    this._location.back();
  }

  /**
   * @description get all versions of report
   */
  getAllVersionList() {
    this.reportProvider.getReportVersions(this.reportId).subscribe(res => {
      if (res.success) {
        let allReports: Array<ReportVersion> = [];
        allReports = ReportVersion.parseArray(res.result);
        this.reportVersionList = allReports.filter(i => !i.MAIN);
        this.mainReportVersion = allReports.find(el => el.MAIN);

        this.reportVersionList = this.sortData();
      } else {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });

  }

  /**
   * @description sort versions
   */
  sortData() {
    return this.reportVersionList.sort((a, b) => {
      return <any>new Date(b.CREATED_DATE) - <any>new Date(a.CREATED_DATE);
    });
  }

  /**
   * @description open note modal
   */
   openShowNoteModal(object) {
    this.modalService.show(ShowNoteModalComponent, Object.assign({
      initialState: {
        reportVersionId: object.ID
      }
    }, { class: 'modal-lg' }));
  }

}
